var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#7AC943"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3887 19.7644V14.0381L10.9275 14.0663V10.5394L15.3769 10.5113V13.9847H14.9156V17.3484L11.3887 19.7644Z",
    fill: "#AB5832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.031 12.5616L11.251 25.4034L11.3494 37.275L36.5916 37.0359L36.6282 24.3797L24.031 12.5616Z",
    fill: "#FFF3E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7728 35.1909L11.656 34.7044V25.1194L10.8347 25.6678C10.8319 25.6678 10.9247 35.1909 10.7728 35.1909Z",
    fill: "#5F4E47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15 25.6369V34.6453L37.0331 35.1319V25.9716L36.15 25.6369Z",
    fill: "#5F4E47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1182 13.9341L10.8319 26.3681V23.2322L24.1322 10.635L37.0332 23.9944V26.6409L24.1182 13.9341Z",
    fill: "#BCAA93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52967 22.695L8.75061 24.1322L10.8403 24.1013C10.8403 24.1013 23.8762 11.4225 24.1575 11.4113C24.4978 11.3972 37.0275 24.3234 37.0275 24.3234L38.8809 24.2953L24.9759 9.31594L22.934 9.18094L9.52967 22.695Z",
    fill: "#AB5832"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12504 23.7722C6.90566 24.0394 7.12223 24.18 7.29941 24.18C7.4766 24.18 9.51848 24.1209 9.51848 24.1209L23.5922 10.4269C23.5922 10.4269 23.9157 10.095 24.1463 10.1063C24.3966 10.1175 24.72 10.4353 24.72 10.4353L38.8613 24.2981C38.8613 24.2981 40.4729 24.3038 40.7288 24.2391C41.0072 24.1716 40.8666 23.9072 40.5235 23.5388C40.2704 23.2659 25.9744 9.12469 25.7382 8.88001C25.035 8.15438 24.6919 7.73251 24.0282 7.76063C23.3616 7.78876 22.9679 8.28094 22.3013 8.89407C22.1044 9.07969 7.21785 23.6597 7.12504 23.7722Z",
    fill: "#ED6C31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 28.7334H35.1797V26.3344C35.1797 25.8872 34.8169 25.5272 34.3725 25.5272H32.2969V28.7334Z",
    fill: "#A6CFD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4306 28.7334V25.5272H29.1806C28.7334 25.5272 28.3734 25.89 28.3734 26.3344V28.7363H31.4306V28.7334Z",
    fill: "#A6CFD5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4306 29.6447H28.3734V31.8947C28.3734 32.3419 28.7362 32.7019 29.1806 32.7019H31.4306V29.6447Z",
    fill: "#A6CFD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 29.6447V32.7019H34.3725C34.8197 32.7019 35.1797 32.3391 35.1797 31.8947V29.6447H32.2969Z",
    fill: "#A6CFD5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3359 28.7334H19.2188V26.3344C19.2188 25.8872 18.8559 25.5272 18.4116 25.5272H16.3359V28.7334Z",
    fill: "#A6CFD5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 28.7334V25.5272H13.2169C12.7697 25.5272 12.4097 25.89 12.4097 26.3344V28.7363H15.4669V28.7334Z",
    fill: "#A6CFD5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 29.6447H12.4125V31.8947C12.4125 32.3419 12.7753 32.7019 13.2197 32.7019H15.4697V29.6447H15.4669Z",
    fill: "#A6CFD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3359 29.6447V32.7019H18.4116C18.8588 32.7019 19.2188 32.3391 19.2188 31.8947V29.6447H16.3359Z",
    fill: "#A6CFD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1582 36.0178C20.1582 36.0178 20.116 29.0597 20.1582 27.3019C20.2003 25.5469 21.8485 24.0281 23.7582 24.0928C26.1207 24.1744 27.3357 25.5019 27.4228 27.2147C27.51 28.9275 27.51 36.1247 27.51 36.1247L20.1582 36.0178Z",
    fill: "#D27857"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0384 36.3947C21.0384 36.3947 21.0047 28.9809 21.0384 27.6084C21.0806 25.9069 22.3631 25.0125 23.8537 25.0969C25.5891 25.1953 26.4469 26.1178 26.5144 27.4594C26.5819 28.7981 26.5819 36.4003 26.5819 36.4003L21.0384 36.3947Z",
    fill: "#AB5932"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6847 30.3506C25.6791 29.13 25.6678 28.0528 25.6509 27.7238C25.6059 26.8378 24.9759 26.1488 23.7525 26.1066C22.7653 26.0728 21.9525 26.8434 21.93 27.7519C21.9216 28.0866 21.9244 29.1384 21.93 30.3366L25.6847 30.3506Z",
    fill: "#D27857"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9385 31.7203C21.9497 33.3544 21.9638 34.8591 21.9638 34.8591L25.696 34.8703C25.696 34.8703 25.696 33.3713 25.6904 31.7372L21.9385 31.7203Z",
    fill: "#D27857"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6959 30.9778C25.6818 31.3744 25.8422 31.695 26.3118 31.695C26.7815 31.695 26.9531 31.4756 26.9868 31.0509C27.015 30.6712 26.7534 30.3337 26.3118 30.3619C25.8731 30.3928 25.7072 30.6994 25.6959 30.9778Z",
    fill: "#FFBA02"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3904 38.7122C28.3904 38.7122 31.4504 38.7431 33.661 38.6784C35.8716 38.6137 37.4719 38.7122 37.801 38.3803C38.1301 38.0512 38.1244 35.2472 36.5916 34.4878C35.1826 33.7903 34.2713 34.499 33.7876 34.5469C33.1491 34.6115 32.3588 34.215 31.7794 34.2037C29.386 34.1531 28.5479 36.0347 28.5479 36.0347L28.3904 38.7122Z",
    fill: "#728037"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0865 38.4816C10.3425 38.7206 12.2972 38.7291 14.6569 38.7122C17.0165 38.6953 18.915 38.7178 18.915 38.7178L19.3087 36.3356L18.8306 35.9391C18.8306 35.9391 18.884 34.7466 17.3794 34.3387C16.3387 34.0575 15.4331 34.5216 14.5584 34.5356C13.6837 34.5525 12.8765 34.1559 11.9034 34.3866C10.9978 34.6003 10.2919 35.1909 10.005 36.3834C9.80529 37.2103 9.85591 38.265 10.0865 38.4816Z",
    fill: "#728037"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6338 41.2041L18.6535 38.715H18.8363L18.8335 35.9419H28.6013L28.5675 38.715H28.7813V41.1394C28.7785 41.1366 18.6338 41.2181 18.6338 41.2041Z",
    fill: "#B0B0B0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7785 40.1156V41.1366L18.631 41.2041L18.6394 40.1072L28.7785 40.1156Z",
    fill: "#9B9B9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8306 37.635L28.5759 37.6378V38.7122H18.8306V37.635Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.f2584c4bb92971c6fd29f42846cf5606.svg";
export { ForwardRef as ReactComponent };